var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRotateLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 4C8.21875 4 6.625 4.78125 5.53125 6H7C7.5625 6 8 6.4375 8 7C8 7.5625 7.5625 8 7 8H3C2.4375 8 2 7.5625 2 7V3C2 2.4375 2.4375 2 3 2C3.5625 2 4 2.4375 4 3V4.71875C5.46875 3.0625 7.625 2 10 2C14.4062 2 18 5.59375 18 10C18 14.4062 14.4062 18 10 18C7.28125 18 4.875 16.6562 3.4375 14.5625C3.125 14.125 3.21875 13.5 3.6875 13.1875C4.125 12.875 4.75 12.9688 5.0625 13.4375C6.15625 14.9688 7.96875 16 10 16C13.3125 16 16 13.3125 16 10C16 6.6875 13.3125 4 10 4Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateLeft);
export default __webpack_public_path__ + "static/media/rotate_left.fb20cac74301cc0aa9c914a5d1c481f8.svg";
export { ForwardRef as ReactComponent };